import { ReactNode } from "react";

import { View } from "./View";

interface IHoverDropDown {
  text: string;
  className?: string;
  buttonClassName?: string;
  contentClassName?: string;
  renderButton?: ReactNode;
  children: ReactNode;
}

export const HoverDropDown = (props: IHoverDropDown) => {
  return <View renderButton={props.renderButton} {...props} />;
};
